import { castRouteIds } from 'plugins/router/routes/castRouteIds'
import routesLimited from '@/constants/routesLimited'
import { hideCis } from 'plugins/router/routes/cis'
import { hideTasks } from 'plugins/router/routes/task'
import type { RouteRecordRaw } from 'vue-router'

const dashboard: RouteRecordRaw = {
	path: '/dashboard',
	alias: '/',
	name: 'dashboard',
	children: [
		{
			path: 'tasks/:taskId',
			component: () => import('@/components/modules/Tasks/View.vue'),
			name: 'dashboardTask',
			meta: {
				// Wiedervorlagen-Dialog hängt am Schalter hide_tasks; hide_ticket liefert die API gar nicht,
				// die Route fehlte dadurch bei jedem Mandanten (KPI-/Widget-Zeilen ohne Link)
				hidden: hideTasks,
				subs: [routesLimited.subModules.tasks],
			},
			props: castRouteIds,
		},
		{
			path: 'cis',
			component: () => import('@/components/modules/Cis/View.vue'),
			name: 'dashboardCis',
			// wie buildingCis: Schalter hide_cis und Abo-Modul cis (AAR-1984 M1)
			meta: {
				hidden: hideCis,
				subs: [routesLimited.subModules.cis],
			},
			props: (route) => {
				return {
					cisId: parseInt(route.query.cisId as string),
				}
			},
		},
	],
	component: () => import('components/modules/Dashboard/Dashboard.vue'),
	meta: {
		title: 'Start',
		icon: '$dashboard',
		name: 'dashboard',
		auth: true,
		nav: true,
		ordering: 0,
		frame: 'old',
	},
}

export { dashboard }
